// extracted by mini-css-extract-plugin
export default {"container":"gB-z","title":"hB-z","link":"iB-z"};